// extracted by mini-css-extract-plugin
module.exports = {"summary":"_2totM","trucks_row":"_31AZF","region_details":"_2DCZk"};